export default "__VITE_ASSET__BUBzdTgr__"